import { defineMessages } from 'react-intl';

export const shareFreightModalMessages = defineMessages({
  title: {
    id: 'MSD0Ft',
    defaultMessage: 'Share Documents',
    description: 'Title of the modal for sharing freight shipment documents via email',
  },
  instructions: {
    id: 'Puj/pG',
    defaultMessage: 'Enter an email below. Click Add for more than one recipient.',
    description: 'Instructional text at the top of the share documents modal',
  },
  recipientLabel: {
    id: 'QRxpFc',
    defaultMessage: 'Recipient',
    description: 'Label for the email recipient input field',
  },
  emailPlaceholder: {
    id: '+RR3Ns',
    defaultMessage: 'Enter email',
    description: 'Placeholder text for the recipient email input',
  },
  addButton: {
    id: 'S2Nx43',
    defaultMessage: 'Add',
    description: 'Button to add an email address to the recipient list',
  },
  shareMyEmail: {
    id: 'gh7TPC',
    defaultMessage: 'Share with my email ({email})',
    description: "Checkbox label to include the logged-in user's email as a recipient",
  },
  cancelButton: {
    id: 'KpcRIn',
    defaultMessage: 'Cancel',
    description: 'Button to cancel sharing and close the modal',
  },
  shareButton: {
    id: 'ZZPvp6',
    defaultMessage: 'Share',
    description: 'Button to send the documents to the specified recipients',
  },
  incompleteEmailError: {
    id: 's18eln',
    defaultMessage: 'Incomplete email address',
    description: 'Error shown below the email input when Share is clicked with a partial/invalid email in the field',
  },
});
